import React, { useEffect, useState } from 'react';
import {
    Box,
    Grid,
    Typography,
    Paper,
    Avatar,
    Button,
    IconButton,
    Stack,
    Card,

} from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import VideoCallIcon from '@mui/icons-material/VideoCall';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import CancelIcon from '@mui/icons-material/Cancel';
import ReplayIcon from '@mui/icons-material/Replay';
import Badge from '@mui/material/Badge';
import { DateCalendar, DayCalendarSkeleton, StaticDatePicker, PickersDay } from '@mui/x-date-pickers';
import doctor from '../../Assets/images/doctor.png';
import pharmacy from '../../Assets/images/drugs.png';
import lab from '../../Assets/images/microscope.png';
import hospital from '../../Assets/images/hospital.png';

import dayjs from 'dayjs';
import ZoomMeeting from './ZoomMeeting';
import ZoomMtgEmbedded from "@zoom/meetingsdk/embedded";
import { useNavigate } from 'react-router-dom';
import { get, put, post } from '../../utility/fetchWeb';
// import { get as gets, put as puts } from '../../utility/fetchWeb';
import notification from '../../utility/notification';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import AppointmentModal from '../Layout/UpdateAppointmentModal';
import { extractZoomCredentials } from '../../utility/general';
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

import { Check } from '@mui/icons-material';
import DeclineModal from '../modals/DeclineModal';
import ScheduleUpdateModal from '../modals/ScheduleUpdateModal';
import "./medical-dashboard.css"
dayjs.extend(customParseFormat);

const generateDateRange = () => {
    const today = new Date();
    const dates = [];

    // Start from 7 days ago
    for (let i = -7; i <= 7; i++) {
        const date = new Date(today);
        date.setDate(today.getDate() + i);

        dates.push({
            date: date.getDate(),
            day: date.toLocaleDateString('en-US', { weekday: 'short' }).toUpperCase(),
            fullDate: date // Keep full date for comparison
        });
    }

    return dates;
};

const markedDates = [
    dayjs('2025-05-08'),
    dayjs('2025-05-17'),
    dayjs('2025-05-20'),
    dayjs('2025-05-21'),
    dayjs('2025-06-02'),
    dayjs('2025-06-10'),
];

const appointments = [
    {
        title: 'Persistent Headache',
        doctor: 'Dr. Ember Wynn',
        location: 'Healing Stripes Hospitals',
        date: 'May 8, 2025',
        time: '10:30am',
        type: 'Online Consultation',
        avatar: '/path/to/avatar1.jpg',
        online: true,
    },
    {
        title: 'Quarterly Scaling & Polishing',
        doctor: 'Dr. Amanda Chukwuka',
        location: '',
        date: 'May 17, 2025',
        time: '10:30am',
        type: 'In-Person',
        avatar: '/path/to/avatar2.jpg',
    },
    // ... other appointments
];

const services = [
    { label: 'Doctor', icon: doctor },
    { label: 'Pharmacy', icon: pharmacy },
    { label: 'Lab', icon: lab },
    { label: 'Hospitals', icon: hospital },
];




const Appointment = () => {

    const [isLoading, setIsLoading] = React.useState(false);
    const [zoomStarted, setZoomStarted] = React.useState(false);
    const [appointDates, setAppointDates] = useState([]);
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [groupedAppointments, setGroupedAppointments] = useState({});
    const [year, setYear] = useState(2025);
    const [openModal, setOpenModal] = useState(false)
    const [rescheduleData, setRescheduleData] = useState();
    const [zoomMeetingNumber, setZoomMeetingNumber] = useState("")
    const [zoomSignature, setZoomSignature] = useState("")
    const [zoomMeetingPassword, setZoomMeetingPassword] = useState("")

    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    // Initialize selectedDate with today's date
    const [selectedDate, setSelectedDate] = useState(new Date().getDate());
    const [selectedSchedule, setSelectedSchedule] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isNewSchedule, setIsNewSchedule] = useState(false);
    const [patientData, setPatientData] = useState([]);
    const [isDeclineModalOpen, setIsDeclineModalOpen] = useState(false);
    const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);
    const [slots, setSlots] = useState([]);
    const doctorId = sessionStorage.getItem("userId");

    const navigate = useNavigate();



    const handleCloseModal = () => {
        setOpenModal(false)
    }


    const rescheduleAppointment = async (data) => {
        const payload = {
            ...data,
            doctorEmployeeId: rescheduleData?.doctorId,
            healthCareProviderId: rescheduleData?.healthCareProviderId
        }

        let res = await put("/appointment", payload);

        console.log(res);
    }


    const client = ZoomMtgEmbedded.createClient();

    const authEndpoint = ""; // http://localhost:4000
    const sdkKey = "";
    const meetingNumber = "";
    const passWord = "";
    const role = 1;
    const userName = "";
    const userEmail = "";
    const registrantToken = "";
    const zakToken = "";


    async function startMeeting(signature) {
        const meetingSDKElement = document.getElementById("meetingSDKElement");
        try {
            await client.init({
                zoomAppRoot: meetingSDKElement,
                language: "en-US",
                patchJsMedia: true,
                leaveOnPageUnload: true,
            })
            await client.join({
                signature: signature,
                sdkKey: sdkKey,
                meetingNumber: meetingNumber,
                password: passWord,
                userName: userName,
                userEmail: userEmail,
                tk: registrantToken,
                zak: zakToken,
            })
            console.log("joined successfully");
        } catch (error) {
            console.log(error);
        }
    }

    const handleZoomMeeting = (appt) => {
        console.log(appt);
        console.log(appt.zoomJoinUrl)
        let zoomCred = extractZoomCredentials(appt.zoomJoinUrl);
        console.log(zoomCred)
        setZoomMeetingNumber(zoomCred?.meetingNumber)
        setZoomMeetingPassword(zoomCred?.password)

        setZoomStarted(true);
    }


    const getSignature = async () => {
        try {
            const req = await fetch(authEndpoint, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    meetingNumber: meetingNumber,
                    role: 1,
                }),
            });
            const res = await req.json()
            const signature = res.signature;
            startMeeting(signature)
        } catch (e) {
            console.log(e);
        }
    };


    const groupAppointmentsByMonth = (appointments) => {
        const grouped = {};
        console.log(appointments)

        appointments.forEach(appt => {
            const parsed = dayjs(appt.appointDate, 'M/D/YYYY'); // explicitly parse
            const key = parsed.format('MMMM YYYY'); // e.g., "July 2025"

            if (!grouped[key]) grouped[key] = [];
            grouped[key].push(appt);
        });

        console.log(grouped)

        return grouped;
    };


    const cancelAppointment = async (appt) => {
        let res = await put("/appointment/cancel-appointment", {

            isCanceled: true,
            healthCareProviderId: appt?.healthCareProviderId,
            canceledDate: dayjs(new Date()).format('YYYY/MM/DD'),
            canceledTime: dayjs(new Date()).format('HH:mm')
        });
        console.log(res);
        // notification({
        //     type: "error",
        //     message: res
        // })
    }


    const openRescheduleModal = (data) => {
        console.log(data)
        setRescheduleData(data)
        setOpenModal(true)
    }


    function getMonthNumber(monthYearString) {
        const parsed = dayjs(monthYearString, 'MMMM YYYY');
        if (!parsed.isValid()) return null;
        return parsed.month() + 1; // dayjs.month() is 0-based
    }

    const getSlots = async () => {
        try {
            const data = await get(`/Doctors/api/slots/availableByDoctorId?doctorId=${doctorId}`)
            console.log("Waiting slots: ", data)
            if (data.length > 0) {
                setSlots(data);
            } else {
                setSlots([])
            }
        } catch (e) {
            console.log("Error: ", e)
            setSlots([])
        }

    }


    const getAppointments = async () => {
        let res = await get(`/Appointment/doctor/${sessionStorage?.getItem("userId")}`);
        if (res?.status === "success") {
            const dates = res?.data?.map((item) => dayjs(item?.appointDate));
            setAppointDates(dates);

            const grouped = groupAppointmentsByMonth(res?.data);
            console.log(grouped);
            setGroupedAppointments(grouped);

            if (dates.length > 0) {
                const firstMonth = dates.sort((a, b) => a - b)[0].startOf('month');
                setSelectedMonth(firstMonth);
            }
        }
    };

    // const getAppointmentsByMonth = async () =>{
    //     let monthNumber = selectedMonth?.month() + 1;
    //     let res = await get(`/Appointment/patient/${sessionStorage?.getItem("userId")}/appointment_calendar?year=${year}&month=${monthNumber}`);


    //     console.log(res)
    // }


    // useEffect(()=>{
    //     getAppointmentsByMonth()
    // }, [selectedMonth])


    function CustomDay(props) {
        const { day, outsideCurrentMonth, ...other } = props;

        const isMarked = appointDates.some((d) => d.isSame(day, 'day'));

        return (
            <Badge
                key={day.toString()}
                overlap="circular"
                color="success"
                // variant={isMarked ? 'dot' : 'standard'}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <PickersDay sx={isMarked ? {
                    backgroundColor: "#059909", color: "white", "&:hover": {
                        backgroundColor: "#047b08", // darker green on hover
                    },
                } : ""} day={day} outsideCurrentMonth={outsideCurrentMonth} {...other} />
            </Badge>
        );
    }

    useEffect(() => {
        getAppointments();
        getSlots();
    }, [])

    const toggleDrawer = () => {
        setIsDrawerOpen(!isDrawerOpen)
    }

    const getStatusColor = (appointment) => {
        if (appointment.isCanceled) return "#ff6b6b"
        if (appointment.isAdmitted) return "#4ecdc4"
        return "#51cf66"
    }

    const getStatusText = (appointment) => {
        if (appointment.isCanceled) return "Canceled"
        if (appointment.isAdmitted) return "Admitted"
        return "Scheduled"
    }

    const handleScheduleClick = (schedule) => {
        setSelectedSchedule(schedule);
        setIsNewSchedule(false);
        setIsModalOpen(true);
    };

    const handleCreateNewSchedule = () => {
        setSelectedSchedule({});
        setIsNewSchedule(true);
        setIsModalOpen(true);
    };

    const handleAcceptAppointment = async (appointmentId) => {
        try {
            const response = await post(`/Appointment/appointments/${appointmentId}/accept-appointment`);
            if (response.message === 'Appointment accepted.') {
                notification({
                    title: 'Success',
                    message: 'Appointment accepted successfully',
                    type: 'success'
                });
                getAppointments(); // Refresh the appointments list
            }
        } catch (error) {
            notification({
                title: 'Error',
                message: 'Failed to accept appointment',
                type: 'error'
            });
            console.error('Error accepting appointment:', error);
        }
    };

    const handleDeclineAppointment = async (appointmentId, reason) => {
        try {
            const response = await post(`/Appointment/appointments/${appointmentId}/decline`, {
                reason: reason
            });

            if (response.message === 'Appointment declined and notifications sent.') {
                notification({
                    title: 'Success',
                    message: 'Appointment declined successfully',
                    type: 'success'
                });
                getAppointments(); // Refresh the appointments list
            }
        } catch (error) {
            notification({
                title: 'Error',
                message: 'Failed to decline appointment',
                type: 'error'
            });
            console.error('Error declining appointment:', error);
        } finally {
            setIsDeclineModalOpen(false);
            setSelectedAppointmentId(null);
        }
    };

    // Update the formatTime function to include date
    const formatTime = (dateString) => {
        const date = new Date(dateString);
        return {
            date: date.toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            }),
            time: date.toLocaleTimeString('en-US', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            })
        };
    };

    const getAppointmentActions = (appointment) => {
        switch (appointment.status) {
            case "Accepted":
                return (
                    <>
                        <IconButton
                            onClick={() => handleZoomMeeting(appointment)}
                            className='pointer'
                            color="success"
                            disabled={!appointment.zoomJoinUrl}
                        >
                            <VideoCallIcon />
                        </IconButton>
                        <IconButton color="success">
                            <ChatBubbleOutlineIcon />
                        </IconButton>
                        <Button
                            onClick={() => cancelAppointment(appointment)}
                            size="small"
                            startIcon={<CancelIcon />}
                            color="error"
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={() => openRescheduleModal(appointment)}
                            size="small"
                            startIcon={<ReplayIcon />}
                            color="primary"
                        >
                            Reschedule
                        </Button>
                    </>
                );

            case "Pending":
                return (
                    <>
                        <Button
                            onClick={() => handleAcceptAppointment(appointment?.id)}
                            size="small"
                            startIcon={<Check />}
                            color="primary"
                        >
                            Accept
                        </Button>
                        <Button
                            onClick={() => {
                                setSelectedAppointmentId(appointment?.id);
                                setIsDeclineModalOpen(true);
                            }}
                            size="small"
                            startIcon={<CancelIcon />}
                            color="error"
                        >
                            Decline
                        </Button>
                    </>
                );

            case "Declined":
                return (
                    <Button
                        onClick={() => handleAcceptAppointment(appointment?.id)}
                        size="small"
                        startIcon={<Check />}
                        color="primary"
                    >
                        Accept
                    </Button>
                );

            case "Cancelled":
                return (
                    <Button
                        onClick={() => openRescheduleModal(appointment)}
                        size="small"
                        startIcon={<ReplayIcon />}
                        color="primary"
                    >
                        Reschedule
                    </Button>
                );

            default:
                return null;
        }
    };

    return (
        <Paper elevation={1} sx={{ p: 2, width: "100%" }}>
            <Grid className="anomaly" container spacing={8} p={3}>

                {/* Left Calendar and Services */}
                <Grid item xs={12} md={4}>
                    <Button startIcon={<ArrowBackIosIcon />} onClick={() => navigate(-1)} sx={{ mb: 3 }}>
                        Back
                    </Button>

                    <Box mt={2} textAlign="center">
                        <DateCalendar
                            // sx={{ width: "100%", margin: '0 auto' }}
                            // value={dayjs()}
                            value={selectedMonth}
                            onChange={(newValue) => setSelectedMonth(newValue.startOf('month'))}
                            responsive
                            // onChange={(newValue) => console.log(newValue?.format('YYYY-MM-DD'))}
                            displayStaticWrapperAs="desktop"
                            // Here’s the magic:
                            slots={{
                                day: CustomDay,
                            }}
                        />
                    </Box>

                    {/* <Box mt={4}>
                        <Typography variant="subtitle2">Book An Appointment Today!</Typography>
                        <Grid container spacing={2} mt={1}>
                            {services.map((s) => (
                                <Grid
                                    item xs={3}
                                    onClick={() => {
                                        if (s.label === "Doctor") {
                                            navigate("/doctors")
                                        }
                                        else if (s.label === "Laboratory") {
                                            navigate("/laboratory")
                                        }
                                        else if (s.label === "Pharmacy") {
                                            navigate("/pharmacy")
                                        }
                                        else if (s.label === "Hospitals") {
                                            navigate("/hospital")
                                        }
                                    }}
                                    key={s.label}
                                    textAlign="center"
                                >
                                    <div className='rounded-icon'>
                                        <img src={s.icon} alt={s.label} width={36} />
                                    </div>
                                    <Typography variant="caption">{s.label}</Typography>
                                </Grid>
                            ))}
                        </Grid>
                    </Box> */}

                </Grid>

                {/* Right Appointments */}
                <Grid item xs={12} md={8}>
                    <Typography variant="h6" mb={2}>
                        Appointments in {selectedMonth?.format('MMMM YYYY')}
                    </Typography>

                    <Stack direction="row" spacing={2} mb={2}>
                        <Button
                            onClick={toggleDrawer}
                        >
                            ← Manage My Schedule
                        </Button>
                        <Button
                            onClick={() =>
                                setSelectedMonth(prev => prev.subtract(1, 'month'))
                            }
                        // disabled={!groupedAppointments[selectedMonth?.subtract(1, 'month').format('MMMM YYYY')]}
                        >
                            Previous Month
                        </Button>
                        <Button
                            onClick={() =>
                                setSelectedMonth(prev => prev.add(1, 'month'))
                            }
                        // disabled={!groupedAppointments[selectedMonth?.add(1, 'month').format('MMMM YYYY')]}
                        >
                            Next Month
                        </Button>

                    </Stack>


                    <Stack spacing={2}>
                        {(groupedAppointments[selectedMonth?.format('MMMM YYYY')] || []).map((appt, idx) => (

                            <Paper key={idx} elevation={1} sx={{ p: 2 }}>
                                <Grid container alignItems="center" spacing={2}>
                                    <Grid item>
                                        <Avatar src={appt.avatar} alt={appt.doctor} />
                                    </Grid>
                                    <Grid item xs>
                                        <Typography variant="subtitle1">{appt.title}</Typography>
                                        <Typography variant="body2" color="text.secondary">
                                         Meeting with {appt.patientName} • {appt.location}
                                        </Typography>
                                        
                                        <Typography variant="caption" color="text.secondary">
                                            {appt.appointDate} | {new Date(appt.appointDateTime).toLocaleTimeString()} | {appt.type || "Online Consultation"}
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        {getAppointmentActions(appt)}
                                    </Grid>
                                </Grid>
                            </Paper>
                        ))}
                    </Stack>
                </Grid>
                {/* Schedule Management Drawer */}
                <div className={`drawer-overlay ${isDrawerOpen ? "open" : ""}`} onClick={toggleDrawer}></div>
                <div className={`schedule-drawer ${isDrawerOpen ? "open" : ""}`}>
                    <div className="drawer-header">
                        <button className="close-btn2" onClick={toggleDrawer}>
                            ←
                        </button>
                        <h3>Manage My Schedule</h3>
                    </div>

                    <div className="schedule-table">
                        <div className="table-header">
                            <div className="header-cell">Date</div>
                            <div className="header-cell">Start Time</div>
                            <div className="header-cell">End Time</div>
                            <div className="header-cell">Status</div>
                        </div>

                        {slots?.map((slot, index) => {
                            const startDateTime = formatTime(slot.startTimeUtc);
                            const endDateTime = formatTime(slot.endTimeUtc);

                            return (
                                <div
                                    key={slot.id || index}
                                    className="table-row"
                                    onClick={() => handleScheduleClick(slot)}
                                >
                                    <div className="cell">
                                        {startDateTime.date}
                                    </div>
                                    <div className="cell">
                                        {startDateTime.time}
                                    </div>
                                    <div className="cell">
                                        {endDateTime.time}
                                    </div>
                                    <div className="cell">
                                        <span className={`status-indicator ${slot.isBooked ? 'booked' : 'available'}`}>
                                            {slot.isBooked ? 'Booked' : 'Available'}
                                        </span>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    <button
                        className="update-schedule-btn"
                        onClick={handleCreateNewSchedule}
                    >
                        Create New Schedule
                    </button>
                </div>

                <ScheduleUpdateModal
                    isOpen={isModalOpen}
                    onClose={() => {
                        setIsModalOpen(false);
                        setIsNewSchedule(false);
                    }}
                    schedule={selectedSchedule || {}}
                    isNewSchedule={isNewSchedule}
                />
                <DeclineModal
                    isOpen={isDeclineModalOpen}
                    onClose={() => {
                        setIsDeclineModalOpen(false);
                        setSelectedAppointmentId(null);
                    }}
                    onDecline={(reason) => handleDeclineAppointment(selectedAppointmentId, reason)}
                />

                <div id="meetingSDKElement">
                    {/* Zoom Meeting SDK Component View Rendered Here */}
                </div>

                {
                    zoomStarted &&
                    <Card sx={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <ZoomMeeting
                            sdkKey={process.env.REACT_APP_ZOOM_SDK_KEY}
                            signature={zoomSignature}
                            meetingNumber={zoomMeetingNumber}
                            password={zoomMeetingPassword}
                            role={1}
                            userName={sessionStorage?.getItem("name")}
                            userEmail={sessionStorage?.getItem("email")}
                        />
                    </Card>

                }


                {
                    openModal && <AppointmentModal
                        open={openRescheduleModal}
                        onClose={handleCloseModal}
                        onSubmit={rescheduleAppointment}
                        initialData={rescheduleData}
                    />
                }

            </Grid>
        </Paper>
    );
};

export default Appointment;
